import React from 'react'
import styles from '../templatePage/style/step-header-mod.module.less'
import {
  IconArrowLeft,
  IconArrowRight,
  IconCheck,
} from '@arco-iconbox/react-aidb-v2'

function StepHeaderMod(props) {
  const { step } = props

  const curStep = props.curStep

  return (
    <div className={styles.header}>
      <div
        className={styles.header_left}
        onClick={() => (window.location.href = '/home')}>
        <div className={styles.backIcon}>
          <IconArrowLeft />
        </div>
        <span>{props.title}</span>
      </div>
      {!props.hideStep && (
        <div className={styles.header_step}>
          {step.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => {
                  // 调用父组件传递的回调函数，修改curStep的值
                  props.jumpTo(index, 'header')
                  props.onItemSelected(item.name)
                }}
                className={`${styles.step_item} ${
                  curStep >= index ? styles.active : ''
                }`}>
                {index === 0 ? null : (
                  <div className={styles.step_item_icon}>
                    <IconArrowRight />
                  </div>
                )}
                <div className={styles.step_item_index}>
                  {curStep > index ? <IconCheck /> : index + 1}
                </div>
                <div className={styles.step_item_title}>{item.name}</div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default StepHeaderMod
